import React from "react";
import { Col, Modal, Row, Spin } from "antd";
import { Grid } from "antd";
import { MyButton, MyText } from "../../../common";
import { PauseIcon, PlayIcon } from "../../../../assets";
import { HtmlContentWrapper } from "../../../../pages/MaterialsDetail/style";
import {
    CustomCollapse,
    LessonPageWrapper,
    PlayButtonContainer,
    StepIconWrapper,
    StyledButton,
} from "./style";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";

interface Lesson {
    id: number;
    name: string;
    content: string;
    description?: string;
    is_completed?: boolean;
    isDayLocked?: boolean;
}

interface LessonCardProps {
    lessons: Lesson[];
    lessonContent: Record<number, any>;
    activeKey: string | string[];
    completedSteps: number[];
    buttonAnimation: Record<number, boolean>;
    hideButton: Record<number, boolean>;
    loadingPDF: Record<number, boolean>;
    modalVisible: boolean;
    selectedVideo: string | null;
    title?: string;
    dayId: number; 
    isDayLocked?: boolean;
    onCollapseChange: (key: string | string[], lessonId: number) => void;
    onCompleteStep: (index: number, lessonId: number) => void;
    onOpenPDF: (index: number, item: Lesson) => void;
    onCloseModal: () => void;
    showModal: (dayId: number) => void;
    adaptIframe: (html: string) => string;
}

export const LessonCard: React.FC<LessonCardProps> = ({
    lessons,
    lessonContent,
    activeKey = [],
    completedSteps = [],
    buttonAnimation = {},
    hideButton = {},
    loadingPDF,
    modalVisible,
    isDayLocked = false,
    selectedVideo,
    title,
    dayId,
    showModal,
    onCollapseChange,
    onCompleteStep,
    onOpenPDF,
    onCloseModal,
    adaptIframe,
}) => {
    const { t } = useTranslation("common");
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = screens.xs;
    const isTablet = screens.md && !screens.xl && !screens.xxl;
    const { Panel } = require("antd").Collapse;

    return (
        <Col span={24}>
            <Col span={24}>
                {!isMobile && (
                    <MyText
                        color="rgba(19, 15, 38, 1)"
                        size={32}
                        weight={800}
                        style={{ fontFamily: "Nunito", display: "block", marginBottom: 32 }}
                    >
                        {title}
                    </MyText>
                )}
                <LessonPageWrapper style={{ padding: "0" }}>
                    <Row style={{ width: "100%" }}>
                        {lessons.length > 0 ? (
                            lessons.map((item, index) => {
                                const ownKey = String(item.id);
                                const activeKeysArr = Array.isArray(activeKey) ? activeKey : [activeKey];
                                const isOwnOpen = activeKeysArr.includes(ownKey);

                                const isLocked = !isOwnOpen && (
                                    isDayLocked || (
                                        index > 0 &&
                                        !lessons[index - 1].is_completed &&
                                        !activeKeysArr.includes(String(lessons[index - 1].id))
                                    )
                                );
                                return (
                                <Col span={24} key={item.id}>
                                    <CustomCollapse
                                        activeKey={activeKey}
                                        onChange={(key) => {
                                            if (isLocked) return;
                                            onCollapseChange(key, item.id);
                                        }}
                                        style={{ marginBottom: "16px" }}
                                    >
                                        <Panel
                                            key={String(item.id)}
                                            collapsible={isLocked ? "disabled" : undefined}
                                            header={
                                                <>
                                                    <Col
                                                        span={24}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            opacity: isLocked ? 0.5 : 1,
                                                        }}
                                                    >
                                                        <Col
                                                            span={screens.xs ? 20 : 22}
                                                            style={{
                                                                display: "flex",
                                                                gap: "24px",
                                                                alignItems: screens.xs ? undefined : "center",
                                                            }}
                                                        >
                                                            <Col
                                                                span={screens.xs ? 24 : 1}
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: isMobile ? "row" : "column",
                                                                    alignItems: isMobile ? "flex-end" : "center",
                                                                    gap: isMobile ? "5px" : "initial",
                                                                    marginBottom: isMobile ? "12px" : "0",
                                                                }}
                                                            >
                                                                <MyText
                                                                    color="#0A033C"
                                                                    size={28}
                                                                    weight={800}
                                                                    style={{ fontFamily: "Nunito" }}
                                                                >
                                                                    {index + 1}
                                                                </MyText>
                                                            </Col>
                                                            {!isMobile && (
                                                                <Col span={22}>
                                                                    <MyText
                                                                        color="#364153"
                                                                        size={18}
                                                                        weight={400}
                                                                        style={{ lineHeight: "20px" }}
                                                                    >
                                                                        {item.name.replace(/<br\s*\/?>/gi, "")}
                                                                    </MyText>
                                                                </Col>
                                                            )}
                                                        </Col>
                                                       <Col span={screens.xs ? 3 : 1} style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}>
                                                        {item.is_completed ? (
                                                            <StepIconWrapper completed={true}>
                                                            <svg viewBox="0 0 14 11" fill="none">
                                                                <path d="M1 5L5 9L13 1" />
                                                            </svg>
                                                            </StepIconWrapper>
                                                        ) : (
                                                           <PlayButtonContainer>
                                                                {(Array.isArray(activeKey) ? activeKey : [activeKey]).includes(String(item.id)) ? (
                                                                    <PauseIcon
                                                                        style={{ color: "rgba(255, 149, 0, 1)" }}
                                                                    />
                                                                ) : (
                                                                    <PlayIcon isActive={false} />
                                                                )}
                                                            </PlayButtonContainer>
                                                        )}
                                                        </Col>
                                                    </Col>
                                                    {isMobile && (
                                                        <MyText
                                                            color="rgba(71, 74, 87, 1)"
                                                            size={18}
                                                            weight={400}
                                                            style={{ lineHeight: "20px" }}
                                                        >
                                                            {item.name.replace(/<br\s*\/?>/gi, "")}
                                                        </MyText>
                                                    )}
                                                </>
                                            }
                                        >
                                            <div id={`export-content-${index}`}>
                                                {lessonContent[item.id] ? (
                                                    <>
                                                        {lessonContent[item.id].description && (
                                                            <HtmlContentWrapper
                                                                screens={screens}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: adaptIframe(lessonContent[item.id].description),
                                                                }}
                                                            />
                                                        )}
                                                        {lessonContent[item.id].content && (
                                                            <HtmlContentWrapper
                                                                screens={screens}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: adaptIframe(lessonContent[item.id].content),
                                                                }}
                                                            />
                                                        )}
                                                    </>
                                                ) : (
                                                    <Spin />
                                                )}
                                            </div>

                                            <Modal
                                                open={modalVisible}
                                                onCancel={onCloseModal}
                                                footer={null}
                                                width={isMobile ? "100%" : "50%"}
                                                bodyStyle={{ padding: isMobile ? 14 : 30 }}
                                                style={{ top: 70 }}
                                            >
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        paddingBottom: isMobile ? "100%" : "56.25%",
                                                        height: 0,
                                                    }}
                                                >
                                                    <iframe
                                                        title="video"
                                                        src={`https://www.youtube.com/embed/${selectedVideo}`}
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                        }}
                                                    />
                                                </div>
                                            </Modal>

                                        </Panel>
                                    </CustomCollapse>
                                </Col>
                           );})
                        ) : (
                            null
                        )}
                    </Row>
                    
                </LessonPageWrapper>
                <Col span={24}>
                    <Row
                        align="middle"
                        gutter={28}
                    >
                        <Col>
                            <MyButton
                                type="primary"
                                color="blue"
                                style={{
                                    height: 48,
                                    padding: '0 24px',
                                    borderRadius: 12,
                                    fontWeight: 600,
                                }}
                                onClick={() => showModal(dayId)}
                            >
                                Заполнить дневник наблюдений
                            </MyButton>
                        </Col>

                        <Col flex="1">
                            <Row align="middle" gutter={8} wrap={false}>
                                <Col>
                                    <InfoCircleOutlined
                                        style={{
                                            color: '#F18021',
                                            fontSize: 18,
                                        }}
                                    />
                                </Col>


                                <Col flex="1">
                                    <div style={{ lineHeight: '24px' }}>
                                        <MyText
                                            color="#F18021"
                                            size={16}
                                            weight={500}
                                        >
                                            Это важно
                                        </MyText>

                                        <MyText
                                            color="#364153"
                                            size={16}
                                            weight={500}
                                            style={{ marginLeft: 4 }}
                                        >
                                            для того, чтобы видеть изменения в речи ребёнка и
                                            сформировать таблицу прогресса за время марафона.
                                        </MyText>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </Col>
            </Col>
        </Col>
    );
};